import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const getFormsGuestEndpoint = () => {
    const user = JSON.parse(window.sessionStorage.getItem("user") || "{}");

    return user.isGuest ? "formsGuest" : "forms";
};

const getTrialAgreement = async () => {
    const response = await RequestManager.get({
        url: `/forms/trialAgreement/v1`
    });
    return response;
};

const downloadInstanceData = async ({ deploymentId, formInstanceId }) => {
    const response = await RequestManager.get({
        url: `/forms/instance/data/v1/${deploymentId}/${formInstanceId}`
    });
    return response;
};

const addFormInstance = async ({ deploymentId, body }) => {
    const response = await RequestManager.post({
        url: `/forms/v1/${deploymentId}`,
        body
    });
    return response;
};

const editFormInstance = async ({ deploymentId, formInstanceId, body }) => {
    const response = await RequestManager.put({
        url: `/forms/v1/${deploymentId}/${formInstanceId}`,
        body
    });
    return response;
};

const deleteFormInstance = async ({ deploymentId, instanceId }) => {
    const response = await RequestManager.del({
        url: `/forms/v1/${deploymentId}/${instanceId}`
    });
    return response;
};

const getFormsInstances = async ({
    deploymentId,
    size,
    prev,
    firstCursor,
    lastCursor,
    getLatest,
    extraQuery
}) => {
    const urlParams = Utils.getUrlParams({
        size,
        prev,
        firstCursor,
        lastCursor,
        getLatest,
        extraQuery
    });

    const response = await RequestManager.get({
        url: `/forms/v1/${deploymentId}${urlParams}`
    });
    return response;
};

const buildPreview = async ({ deploymentId, formTemplateId }) => {
    const response = await RequestManager.post({
        url: `/${getFormsGuestEndpoint()}/template/buildPreview/v1/${deploymentId}/${formTemplateId}`
    });
    return response;
};

const publishTemplate = async ({ deploymentId, formTemplateId, body }) => {
    const response = await RequestManager.post({
        url: `/forms/template/publish/v1/${deploymentId}/${formTemplateId}`,
        body
    });
    return response;
};

const createNewTemplateVersion = async ({ deploymentId, formTemplateId }) => {
    const response = await RequestManager.post({
        url: `/forms/template/version/v1/${deploymentId}/${formTemplateId}`
    });
    return response;
};

const getFormConfig = async ({ deploymentId }) => {
    const response = await RequestManager.get({
        url: `/${getFormsGuestEndpoint()}/config/v1/${deploymentId}`
    });
    return response;
};

const getDataLists = async ({ deploymentId }) => {
    const response = await RequestManager.get({
        url: `/${getFormsGuestEndpoint()}/data-list/v1/${deploymentId}`
    });
    return response;
};

const addDataList = async ({ deploymentId, body }) => {
    const response = await RequestManager.post({
        url: `/forms/data-list/v1/${deploymentId}`,
        body
    });
    return response;
};

const updateDataList = async ({ deploymentId, dataListId, body }) => {
    const response = await RequestManager.put({
        url: `/forms/data-list/v1/${deploymentId}/${dataListId}`,
        body
    });
    return response;
};

const getTemplates = async ({ deploymentId }) => {
    const response = await RequestManager.get({
        url: `/forms/template/v1/${deploymentId}`
    });
    return response;
};

const getTemplatesUnique = async ({ deploymentId }) => {
    const response = await RequestManager.get({
        url: `/forms/template/unique/v1/${deploymentId}`
    });
    return response;
};

const getTemplate = async ({ deploymentId, formTemplateId }) => {
    const response = await RequestManager.get({
        url: `/forms/template/v1/${deploymentId}/${formTemplateId}`
    });
    return response;
};

const getTemplateByNameVersion = async ({ deploymentId, name, version }) => {
    const response = await RequestManager.get({
        url: `/${getFormsGuestEndpoint()}/template/v1/${deploymentId}/${name}/${version}`
    });
    return response;
};

const getTemplateVersions = async ({
    deploymentId,
    name,
    size,
    prev,
    firstCursor,
    lastCursor,
    getLatest,
    search
}) => {
    const urlParams = Utils.getUrlParams({
        size,
        prev,
        firstCursor,
        lastCursor,
        getLatest,
        extraQuery: { search }
    });
    const response = await RequestManager.get({
        url: `/forms/templateVersions/v1/${deploymentId}/${name}${urlParams}`
    });
    return response;
};

const getSharedSections = async ({
    deploymentId,
    size,
    prev,
    firstCursor,
    lastCursor,
    getLatest,
    query
}) => {
    const urlParams = Utils.getUrlParams({
        size,
        prev,
        firstCursor,
        lastCursor,
        getLatest,
        extraQuery: query
    });
    const response = await RequestManager.get({
        url: `/forms/sharedSection/v1/${deploymentId}${urlParams}`
    });
    return response;
};

const getSharedSectionsWithPublishedVersions = async ({ deploymentId }) => {
    const response = await RequestManager.get({
        url: `/forms/sharedSection/published/v1/${deploymentId}`
    });
    return response;
};

const createSharedSection = async ({ deploymentId, body }) => {
    const response = await RequestManager.post({
        url: `/forms/sharedSection/v1/${deploymentId}`,
        body
    });
    return response;
};

const deleteSharedSection = async ({
    deploymentId,
    sharedSectionGroupingId
}) => {
    const response = await RequestManager.del({
        url: `/forms/sharedSection/v1/${deploymentId}/${sharedSectionGroupingId}`
    });
    return response;
};

const getSharedSectionVersions = async ({
    deploymentId,
    sharedSectionGroupingId,
    size,
    prev,
    firstCursor,
    lastCursor,
    getLatest,
    query
}) => {
    const urlParams = Utils.getUrlParams({
        size,
        prev,
        firstCursor,
        lastCursor,
        getLatest,
        extraQuery: { ...query }
    });
    const response = await RequestManager.get({
        url: `/forms/sharedSection/v1/${deploymentId}/${sharedSectionGroupingId}${urlParams}`
    });
    return response;
};

const getSharedSectionVersion = async ({ deploymentId, sharedSectionId }) => {
    const response = await RequestManager.get({
        url: `/forms/sharedSection/version/v1/${deploymentId}/${sharedSectionId}`
    });

    return response;
};

const createSharedSectionVersion = async ({
    deploymentId,
    sharedSectionGroupingId,
    version
}) => {
    const response = await RequestManager.post({
        url: `/forms/sharedSection/version/v1/${deploymentId}/${sharedSectionGroupingId}/${version}`
    });
    return response;
};

const updateSharedSectionVersion = async ({
    deploymentId,
    sharedSectionId,
    body
}) => {
    const response = await RequestManager.put({
        url: `/forms/sharedSection/version/v1/${deploymentId}/${sharedSectionId}`,
        body
    });
    return response;
};

const publishSharedSectionVersion = async ({
    deploymentId,
    sharedSectionId,
    body
}) => {
    const response = await RequestManager.put({
        url: `/forms/sharedSection/version/publish/v1/${deploymentId}/${sharedSectionId}`,
        body
    });
    return response;
};

const deleteSharedSectionVersion = async ({
    deploymentId,
    sharedSectionId
}) => {
    const response = await RequestManager.del({
        url: `/forms/sharedSection/version/v1/${deploymentId}/${sharedSectionId}`
    });
    return response;
};

const reorderSharedSectionItems = async ({
    deploymentId,
    sharedSectionId,
    body
}) => {
    const response = await RequestManager.put({
        url: `/forms/sharedSection/version/reorder/v1/${deploymentId}/${sharedSectionId}`,
        body
    });
    return response;
};

const createSharedSectionItem = async ({
    deploymentId,
    sharedSectionId,
    body
}) => {
    const response = await RequestManager.post({
        url: `/forms/sharedSection/version/item/v1/${deploymentId}/${sharedSectionId}`,
        body
    });
    return response;
};

const updateSharedSectionItem = async ({
    deploymentId,
    sharedSectionId,
    sharedSectionItemId,
    body
}) => {
    const response = await RequestManager.put({
        url: `/forms/sharedSection/version/item/v1/${deploymentId}/${sharedSectionId}/${sharedSectionItemId}`,
        body
    });
    return response;
};

const deleteSharedSectionItem = async ({
    deploymentId,
    sharedSectionId,
    sharedSectionItemId
}) => {
    const response = await RequestManager.del({
        url: `/forms/sharedSection/version/item/v1/${deploymentId}/${sharedSectionId}/${sharedSectionItemId}`
    });
    return response;
};

const createTemplate = async ({ deploymentId, body }) => {
    const response = await RequestManager.post({
        url: `/forms/template/v1/${deploymentId}`,
        body
    });
    return response;
};

const updateTemplate = async ({ deploymentId, formTemplateId, body }) => {
    const response = await RequestManager.put({
        url: `/${getFormsGuestEndpoint()}/template/v1/${deploymentId}/${formTemplateId}`,
        body
    });
    return response;
};

const activateTemplate = async ({ deploymentId, formTemplateId }) => {
    const response = await RequestManager.put({
        url: `/forms/template/activate/v1/${deploymentId}/${formTemplateId}`
    });
    return response;
};

const deleteTemplate = async ({ deploymentId, templateId }) => {
    const response = await RequestManager.del({
        url: `/forms/template/v1/${deploymentId}/${templateId}`
    });
    return response;
};

const reorderSections = async ({ deploymentId, formTemplateId, body }) => {
    const response = await RequestManager.put({
        url: `/${getFormsGuestEndpoint()}/template/reorder/v1/${deploymentId}/${formTemplateId}`,
        body
    });
    return response;
};

const addSection = async ({ deploymentId, formTemplateId, body }) => {
    const response = await RequestManager.post({
        url: `/${getFormsGuestEndpoint()}/section/v1/${deploymentId}/${formTemplateId}`,
        body
    });
    return response;
};

const updateSection = async ({
    deploymentId,
    formTemplateId,
    sectionId,
    body
}) => {
    const response = await RequestManager.put({
        url: `/${getFormsGuestEndpoint()}/section/v1/${deploymentId}/${formTemplateId}/${sectionId}`,
        body
    });
    return response;
};

const deleteSection = async ({ deploymentId, formTemplateId, sectionId }) => {
    const response = await RequestManager.del({
        url: `/${getFormsGuestEndpoint()}/section/v1/${deploymentId}/${formTemplateId}/${sectionId}`
    });
    return response;
};

const reorderItems = async ({
    deploymentId,
    formTemplateId,
    sectionId,
    body
}) => {
    const response = await RequestManager.put({
        url: `/${getFormsGuestEndpoint()}/section/reorder/v1/${deploymentId}/${formTemplateId}/${sectionId}`,
        body
    });
    return response;
};

const addItem = async ({ deploymentId, formTemplateId, sectionId, body }) => {
    const response = await RequestManager.post({
        url: `/${getFormsGuestEndpoint()}/item/v1/${deploymentId}/${formTemplateId}/${sectionId}`,
        body
    });
    return response;
};

const editItem = async ({
    deploymentId,
    formTemplateId,
    sectionId,
    itemId,
    body
}) => {
    const response = await RequestManager.put({
        url: `/${getFormsGuestEndpoint()}/item/v1/${deploymentId}/${formTemplateId}/${sectionId}/${itemId}`,
        body
    });
    return response;
};

const deleteItem = async ({
    deploymentId,
    formTemplateId,
    sectionId,
    itemId
}) => {
    const response = await RequestManager.del({
        url: `/${getFormsGuestEndpoint()}/item/v1/${deploymentId}/${formTemplateId}/${sectionId}/${itemId}`
    });
    return response;
};

const getLivePreviewUrl = async ({ deploymentId }) => {
    const response = await RequestManager.get({
        url: `/formsGuest/livePreviewUrl/v1/${deploymentId}`
    });
    return response;
};

const getGuideMetadata = async ({ deploymentId }) => {
    const response = await RequestManager.get({
        url: `/formsGuest/guideMetadata/v1/${deploymentId}`
    });
    return response;
};

const Forms = {
    getTrialAgreement,
    getGuideMetadata,
    getLivePreviewUrl,
    downloadInstanceData,
    addFormInstance,
    editFormInstance,
    deleteFormInstance,
    getFormsInstances,
    buildPreview,
    publishTemplate,
    createNewTemplateVersion,
    getFormConfig,
    getDataLists,
    addDataList,
    updateDataList,
    getTemplates,
    getTemplatesUnique,
    getTemplate,
    getTemplateByNameVersion,
    getTemplateVersions,
    getSharedSections,
    getSharedSectionsWithPublishedVersions,
    createSharedSection,
    deleteSharedSection,
    getSharedSectionVersion,
    getSharedSectionVersions,
    updateSharedSectionVersion,
    publishSharedSectionVersion,
    createSharedSectionVersion,
    deleteSharedSectionVersion,
    createSharedSectionItem,
    updateSharedSectionItem,
    deleteSharedSectionItem,
    reorderSharedSectionItems,
    createTemplate,
    updateTemplate,
    activateTemplate,
    deleteTemplate,
    reorderSections,
    addSection,
    updateSection,
    deleteSection,
    reorderItems,
    addItem,
    editItem,
    deleteItem
};

export default Forms;
